import type { TextStyle, ViewStyle } from 'react-native';

export const lableButtonStyleButton: ViewStyle = {
  margin: 0,
  borderRadius: 8,
  justifyContent: 'center'
};

export const lableButtonStyleLabel: TextStyle = { marginVertical: 6 };
